export class CarrierImportColumn {

  public name: string;
  public type: CarrierImportColumnType;
  public sample: any;

  static fromDto(data: any): CarrierImportColumn {
    if (!data) {
      return null;
    }

    const column = new CarrierImportColumn();

    column.name   = data.name;
    column.type   = data.type;
    column.sample = data.sample;

    return column;
  }
}

export enum CarrierImportColumnType {
  STRING    = 'STRING',
  NUMBER    = 'NUMBER',
  ENUM      = 'ENUM'
}
